import { callApiWithAuthorization } from "../../API/CallApi"

export function deleteDirectory (path, directoryName) {
    callApiWithAuthorization('/api/v0/DeleteDirectory', {
        method:"POST",
        headers:{
            "Content-Type":"application/json"
        },
        body:JSON.stringify({
            "directoryName":directoryName,
            "path": path
        })
    })
}

export async function UploadFiletoDirectory (formData) {
    var request = await callApiWithAuthorization('/api/v0/UploadFiletoDirectory' , {
        method: "POST",
        body:formData
    })
    var response = await request.json()
    return response
}

export async function DeleteFile (path , fileName) {
    var request = await callApiWithAuthorization('/api/v0/DeleteFile', {
        method:"POST",
        headers:{
            "Content-Type":"application/json"
        },
        body:JSON.stringify({
            "fileName":fileName,
            "path": path
        })
    })
    var response = await request.json()
    return response
}

export function getDatalakeImageUrl(fileName) {
    return `${process.env.REACT_APP_DATALAKESTORAGE_URL}/${process.env.REACT_APP_DATALAKESTORAGE_RESOURCES}/images/${fileName}`;
}

export function getDatalakeUserImageUrl(organizationId, projectId, fileName) {
    return `${process.env.REACT_APP_DATALAKESTORAGE_URL}/${process.env.REACT_APP_DATALAKESTORAGE_CONTAINER}/${organizationId}/${projectId}/ProjectImages/${fileName}`;
}